import React from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'

import { BaseButton } from 'components/button'
import { localize } from 'helpers/translator'
import {
	getMsalInstance,
	loginWithOffice365,
} from 'helpers/login/office365Helper'
import msIcon from 'assets/views/signup/ms-icon.svg'

import styles from './office_365_login_button.scss'

const Office365LoginButton = props => {

	const msalInstance = getMsalInstance()

	const office365Login = () => {
		loginWithOffice365(
			props.onSuccess,
			props.onFailure,
			props.isOfflineMode
		)
	}

	return (
		<BaseButton
			bgColor='red'
			pill={true}
			fontColor='white'
			onClick={office365Login}
			disabled={!msalInstance}
		>
			<Isvg src={msIcon} cacheGetRequests={true} styleName={'icon'} />
			{ localize('logIn_logInWithOffice') }
		</BaseButton>
	)
}

Office365LoginButton.propTypes = {
	isOfflineMode: PropTypes.bool,
	onSuccess: PropTypes.func,
	onFailure: PropTypes.func,
}

Office365LoginButton.defaultProps = {
	isOfflineMode: false,
	onSuccess: () => {},
	onFailure: () => {},
}

export default CSSModules(Office365LoginButton, styles, {allowMultiple: true})
